import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetSignOut } from '../../redux/auth';

const productBtn = {
  name: 'Productos',
  subMenu: [
    {
      id: 'product-1',
      btnNameSub: 'Fondos',
      url: '/products',
      aliasUrls: ['/simulator/form', '/simulator/result', '/simulator/investment'],
      label: 'Productos',
    },
    {
      id: 'product-2',
      btnNameSub: 'Portfolios',
      url: '/portfolio',
      aliasUrls: [
        '/simulator/portfolio/form',
        '/simulator/portfolio/result',
        '/simulator/portfolio/investment',
      ],
      label: 'Productos',
    },
  ],
};

export const useMenuHandlerDesktop = () => {
  const theme = useTheme();
  //drawer
  const [open, setOpen] = useState(() => {
    const savedOpen = localStorage.getItem('drawerOpen');
    return savedOpen === null ? true : savedOpen === 'true';
  });
  const [expanded, setExpanded] = useState(false);
  //navegación
  const [activeItem, setActiveItem] = useState(null);
  const [activeSubItem, setActiveSubItem] = useState(null);
  const [current, setCurrent] = useState('home');
  const [fromHomeClick, setFromHomeClick] = useState(false);
  //usuario
  const [access, setAccess] = useState(false);
  const [userNotOB, setUserNotOB] = useState(false);
  const [accessWallet, setAccessWallet] = useState(false);
  //others
  const [copyText, setCopyText] = useState('Copiar mi link para referir');
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElDashboard, setAnchorElDashboard] = useState(null);
  const [anchorElTransactions, setAnchorElTransactions] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);

  const { user } = useSelector(state => state.auth);
  const { successSignOut, loadingSignOut } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const querys = useMediaQuery('(max-width:900px)');

  const urlWallet = userNotOB ? '/wallet' : '/completeregistration';

  const walletBtn = {
    name: 'Caja',
    subMenu: [
      {
        id: 'wallet-1',
        btnNameSub: 'Caja Disponible',
        label: 'Caja',
        url: urlWallet,
        aliasUrls: ['/wallet', '/payments', '/withdrawal'],
      },
      {
        id: 'wallet-2',
        btnNameSub: 'Dinero en Tránsito',
        label: 'Caja',
        url: urlWallet,
        aliasUrls: ['/wallet', '/payments', '/withdrawal'],
      },
    ],
  };

  const myDataUrl = userNotOB ? '/myaccount' : '/completeregistration';

  const myAccountBtn = {
    name: 'Mi cuenta',
    subMenu: [
      {
        id: 'my account-3',
        btnNameSub: 'Mis datos',
        url: myDataUrl,
        /*         aliasUrls: ['/myaccount', '/changepassword'], */
      },
      {
        id: 'my account-2',
        btnNameSub: 'Cambiar contraseña',
        url: '/changepassword',
        label: 'Mi cuenta',
      },
    ],
  };

  const menuItems = [
    {
      id: 'menu-1',
      name: 'Productos',
      icon: <ShoppingCartOutlinedIcon />,
      subMenu: productBtn.subMenu,
    },
    {
      id: 'menu-2',
      name: 'Caja',
      icon: <AccountBalanceWalletOutlinedIcon />,
      subMenu: walletBtn.subMenu,
    },
    {
      id: 'menu-3',
      name: 'Mi cuenta',
      icon: <SettingsOutlinedIcon />,
      subMenu: myAccountBtn.subMenu,
    },
  ];

  const handleClick = (event, menuName) => {
    if (!open) {
      setAnchorEl(event.currentTarget);
      setOpenMenu(menuName);
    }
  };

  const handleClickDashboard = event => {
    if (!open) {
      setAnchorElDashboard(event.currentTarget);
      setOpenMenu('dashboard');
    }
  };

  const handleClickTransactions = event => {
    if (!open) {
      setAnchorElTransactions(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenMenu(null);
    setAnchorElDashboard(null);
    setAnchorElTransactions(null);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleAccordionChange = panel => (event, isExpanded) => {
    if (open) {
      setExpanded(isExpanded ? panel : false);
    }
  };

  const handleClickHome = () => {
    setActiveItem('inicio');
    navigate(access ? '/myprofilerisk' : '/profile');
  };

  const handleNavigateDashboard = () => {
    setFromHomeClick(true);
    navigate(access ? '/myprofilerisk' : '/profile');
  };

  const handleNavigateTransactions = val => {
    const path = userNotOB ? '/mytransactions' : '/completeregistration';
    setActiveItem('transacciones');
    navigate(path);
    handleClose();
  };

  const handleNavigate = url => {
    navigate(url);
  };

  const handleNavigateWallet = () => {
    if (userNotOB) {
      setActiveItem('caja');
      navigate('/wallet');
    } else {
      setActiveItem('mi cuenta');
      navigate('/completeregistration');
    }
  };

  useEffect(() => {
    const pathname = location.pathname.replace('/', '');
    setCurrent(pathname ? pathname : 'home');
  }, [location.pathname]);

  useEffect(() => {
    if (
      user?.['custom:checkid-sign-doc'] &&
      user['custom:checkid-sign-doc'] === 'signature_success'
    ) {
      setAccessWallet(true);
      setUserNotOB(true);
    } else {
      setAccessWallet(false);
      setUserNotOB(false);
    }
  }, [user]);

  useEffect(() => {
    if (user?.['custom:profile']) {
      setAccess(true);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      setOpen(true);
      localStorage.setItem('drawerOpen', 'true');
    }
  }, [user?.email]);

  useEffect(() => {
    const path = location.pathname.toLowerCase();

    //Dashboard
    if (path === '/myprofilerisk') {
      setActiveItem('inicio');
      if (fromHomeClick) {
        setFromHomeClick(false);
      }

      //Fondos
    } else if (path.startsWith('/products') || path.startsWith('/simulator')) {
      setActiveItem('productos');
      setActiveSubItem('fondos');

      //Portafolios
    } else if (path.startsWith('/portfolio')) {
      setActiveItem('productos');
      setActiveSubItem('portfolios');

      //Transacciones
    } else if (path.startsWith('/mytransactions')) {
      if (userNotOB) {
        setActiveItem('transacciones');
      } else {
        setActiveItem('mi cuenta');
      }

      //Caja
    } else if (
      path.startsWith('/wallet') ||
      path.startsWith('/payments') ||
      path.startsWith('/withdrawal')
    ) {
      if (userNotOB) {
        setActiveItem('caja');
      } else {
        setActiveItem('mi cuenta');
      }
    } else if (path.startsWith('/completeregistration')) {
      setActiveItem('mi cuenta');

      //Mi cuenta
    } else if (
      path.startsWith('/profileselect') ||
      path.startsWith('/myobjectivesinterests') ||
      path.startsWith('/myaccount') ||
      path.startsWith('/questions') ||
      path.startsWith('/questionsresults')
    ) {
      setActiveItem('mi cuenta');
    }
  }, [location.pathname, userNotOB, fromHomeClick]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (successSignOut && !loadingSignOut) {
      dispatch(resetSignOut());
      navigate('/signin');
    }
  }, [successSignOut, loadingSignOut]);

  useEffect(() => {
    localStorage.setItem('drawerOpen', String(open));
  }, [open]);

  return {
    menuItems,
    theme,
    open,
    expanded,
    access,
    userNotOB,
    accessWallet,
    activeItem,
    setActiveItem,
    copyText,
    current,
    anchorEl,
    setAnchorEl,
    anchorElDashboard,
    anchorElTransactions,
    openMenu,
    user,
    navigate,
    location,
    dispatch,
    successSignOut,
    querys,
    handleClick,
    handleClickDashboard,
    handleClickTransactions,
    handleClose,
    handleDrawerOpen,
    handleDrawerClose,
    handleAccordionChange,
    handleClickHome,
    handleNavigateDashboard,
    handleNavigateTransactions,
    handleNavigate,
    handleNavigateWallet,
  };
};
